import { EmptyState, ErrorState, LimitState, ListSkeleton } from '../../shared/states';

/**
 * Показ состояний экранов (T11.3, `09_UI_UX.md` §6).
 *
 * Требование задачи — состояния не только реализованы, но и
 * продемонстрированы. Показ жил в оболочке приложения, пока профиля не
 * было; с его появлением он переехал сюда и стал строкой меню, а не
 * содержимым вкладки: вкладка «Профиль», показывающая вместо профиля
 * образцы состояний, — это отсутствующий профиль.
 *
 * Собственного экрана-мастерской нет намеренно: спрятанное перестают
 * открывать, и оно тихо расходится с настоящими экранами. Здесь
 * используются те же составляющие, что и в списках, — разойтись им
 * попросту негде.
 */
export function StatesDemo({ onBack }: { onBack: () => void }): React.JSX.Element {
  return (
    <>
      <button type="button" className="back" onClick={onBack}>
        ← В профиль
      </button>

      <p className="screen__subtitle">Состояния экранов — как они выглядят</p>

      <ListSkeleton rows={2} />

      <div className="card">
        <EmptyState
          title="Подписок пока нет"
          hint="Создайте первую — и я сообщу, как только появится подходящая машина."
          action={{ label: 'Создать подписку', onClick: () => undefined }}
        />
      </div>

      <div className="card">
        <ErrorState
          title="Не удалось загрузить"
          hint="Сервис не ответил. Это бывает; попробуйте ещё раз."
          onRetry={() => undefined}
        />
      </div>

      <div className="card">
        <ErrorState
          title="Нет соединения"
          hint="Похоже, интернет пропал. Проверьте связь и попробуйте снова."
          onRetry={() => undefined}
        />
      </div>

      <div className="card">
        <LimitState
          title="Достигнут предел тарифа"
          hint="На бесплатном тарифе одна подписка. Pro снимает ограничение и убирает задержку доставки."
          onUpgrade={() => undefined}
        />
      </div>
    </>
  );
}
